import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import { useAppContext } from "../context/appContext";

import { DashboardPage } from "../pages/DashboardPage";
import { NotFoundPage } from "../pages/NotFoundPage";
// import { ProfilePage } from "../pages/ProfiePage";
import { LoginPage } from "../pages/LoginPage";
import ProtectedRoute from "./ProtectedRoute";
import { ProfileDetailsPage } from "../pages/ProfileDetailsPage";
import { AddDecisionPage } from "../pages/AddDecisionPage";
import { DecisionPage } from "../pages/DecisionPage";
import { SearchPage } from "../pages/SearchPage";
import { UnitPage } from "../pages/UnitPage";
import { AddUnitPage } from "../pages/AddUnitPage";
import { UnitsPage } from "../pages/UnitsPage";
import { AdminPage } from "../pages/AdminPage";
import { CalendarPage } from "../pages/CalendarPage";
import { MeetingsPage } from "../pages/MeetingsPage";
import { MeetingPage } from "../pages/MeetingPage";
import { AddMeetingPage } from "../pages/AddMeetingPage";
import { AccountSettingsPage } from "../pages/AccountSettingsPage";
import { PeoplePage } from "../pages/PeoplePage";

export const LocationDisplay = () => {
	const location = useLocation();
	console.log("location: ", location);

	return <div data-testid="location-display">{location.pathname}</div>;
};

export default function MainRoutes() {
	const { items } = useAppContext();
	const { isUserLogin } = items;
	return (
		<Routes>
			<Route path="/" element={isUserLogin ? <Navigate to="/decisions" replace /> : <LoginPage />} />
			{/* <Route
				path="/dashboard"
				element={
					<ProtectedRoute>
						<DashboardPage />
					</ProtectedRoute>
				}
			/> */}
			<Route
				path="/calendar"
				element={
					<ProtectedRoute>
						<CalendarPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/decisions"
				element={
					<ProtectedRoute>
						<DashboardPage />
					</ProtectedRoute>
				}
			></Route>
			<Route
				path="/decisions/:id"
				element={
					<ProtectedRoute>
						<DecisionPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/units"
				element={
					<ProtectedRoute>
						<UnitsPage />
					</ProtectedRoute>
				}
			>
				<Route
					path=":id"
					element={
						<ProtectedRoute>
							<UnitPage />
						</ProtectedRoute>
					}
				/>
			</Route>
			<Route
				path="/add-unit"
				element={
					<ProtectedRoute>
						<AddUnitPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/meetings"
				element={
					<ProtectedRoute>
						<MeetingsPage />
					</ProtectedRoute>
				}
			>
				<Route
					path=":id"
					element={
						<ProtectedRoute>
							<MeetingPage />
						</ProtectedRoute>
					}
				/>
			</Route>
			<Route
				path="/add-meeting"
				element={
					<ProtectedRoute>
						<AddMeetingPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/people"
				element={
					<ProtectedRoute>
						<PeoplePage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/search"
				element={
					<ProtectedRoute search={true}>
						<SearchPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/add-decision"
				element={
					<ProtectedRoute>
						<AddDecisionPage />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/profile"
				element={
					<ProtectedRoute>
						<Navigate to="/profile/details" replace />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/profile/details"
				element={
					<ProtectedRoute>
						<ProfileDetailsPage title="Personal Data" />
					</ProtectedRoute>
				}
				title="Details"
			/>
			<Route
				path="/profile/settings"
				element={
					<ProtectedRoute>
						<AccountSettingsPage title="Account Settings" />
					</ProtectedRoute>
				}
				title="Details"
			/>
			<Route
				path="/admin-panel"
				element={
					<ProtectedRoute>
						<AdminPage />
					</ProtectedRoute>
				}
			/>
			<Route path="/login" element={!isUserLogin ? <LoginPage /> : <Navigate to="/dashboard" replace />} />
			<Route
				path="/404"
				element={
					<ProtectedRoute>
						<NotFoundPage />
					</ProtectedRoute>
				}
			/>
			<Route path="*" element={<Navigate to="/404" replace />} />
		</Routes>
	);
}
